export default __webpack_public_path__ + "static/communities-e245e3365a807e07c2f4c8adc167662f.png";